import React from 'react';
import { Search, Users, CheckCircle, Send, Calendar, XCircle, Flame } from 'lucide-react';

/**
 * Customer Filters Component
 * Filter controls for customer table
 * @param {Object} props - Component props
 * @param {Array} props.customers - Array of all customers to calculate counts
 * @param {string} props.searchQuery - Current search query
 * @param {Function} props.setSearchQuery - Function to update search query
 * @param {string} props.statusFilter - Current status filter
 * @param {Function} props.setStatusFilter - Function to update status filter
 * @param {Object} props.theme - Theme object with styling properties
 * @param {Object} props.colors - Color palette object
 */
export const CustomerFilters = ({
  customers = [],
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  theme,
  colors
}) => {
  // Calculate counts for each filter based on acquisitionStatus
  const getFilterCount = (filterId) => {
    if (filterId === 'all') {
      return customers.length;
    }
    
    return customers.filter(c => {
      const acquisitionStatus = (c.acquisitionStatus || '').toLowerCase();
      
      switch (filterId) {
        case 'hot-opportunity':
          return acquisitionStatus === 'hot-opportunity';
        case 'appointment-set':
          return acquisitionStatus === 'appointment-set';
          case 'offer-sent':
            return acquisitionStatus === 'offer-sent';
        case 'not-interested':
          return acquisitionStatus === 'not-interested';
        default:
          return false;
      }
    }).length;
  };
  return (
    <div style={{
      background: theme.cardBg,
      borderRadius: '16px',
      border: '1px solid rgba(59, 130, 246, 0.2)',
      padding: '20px',
      marginBottom: '24px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
        <Search size={20} color={colors.primary} />
        <input
          type="text"
          placeholder="Search by name, phone, email, or vehicle..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            flex: 1,
            padding: '12px 16px',
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(59, 130, 246, 0.2)',
            borderRadius: '10px',
            color: theme.text,
            fontSize: '14px',
            outline: 'none'
          }}
        />
      </div>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        {[
          { id: 'all', label: 'All', icon: Users },
          { id: 'hot-opportunity', label: 'Hot Opportunities', icon: Flame },
          { id: 'appointment-set', label: 'Appointment Set', icon: Calendar },
          { id: 'offer-sent', label: 'Offer Sent', icon: Send },
          { id: 'not-interested', label: 'Lost/Declined', icon: XCircle }
        ].map(filter => {
          const count = getFilterCount(filter.id);
          return (
            <button
              key={filter.id}
              onClick={() => setStatusFilter(filter.id)}
              style={{
                padding: '12px 16px',
                background: statusFilter === filter.id ? `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)` : 'rgba(255, 255, 255, 0.1)',
                border: statusFilter === filter.id ? 'none' : '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '10px',
                color: statusFilter === filter.id ? 'white' : theme.text,
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <filter.icon size={18} />
              {filter.label} ({count})
            </button>
          );
        })}
      </div>
    </div>
  );
};

